// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"83":"ReactJson","201":"MirrorAsyncRoot","396":"average-head","705":"MirrorContainer"}[chunkId] || chunkId) + ".chunk.js";
};